<template>
  <div class="needs-validation ml-0">
    <section class="col px-0 pr-lg-3" v-if="memberId">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h1 class="h2 mb-3">Rider Results</h1>
      </div>
      <div role="alert" class="alert alert-warning" v-if="errors">{{errors}}</div>

      <div v-if="Object.values(results).length && loaded">
        <div class="mb-4" v-for="(result, resultIndex) in Object.values(results)" :key="`result${resultIndex}`">
          <h2 class="h5">Results for ACA year {{Object.keys(results)[resultIndex]}}</h2>
          <table class="table table-striped table-sm mb-0">
            <thead class="thead-dark text-uppercase">
              <th>Date</th>
              <th>Draft</th>
              <th class="d-none d-lg-table-cell">Zone</th>
              <th class="d-none d-lg-table-cell">Event</th>
              <th class="d-none d-lg-table-cell">Horse</th>
              <th>Place</th>
              <th class="d-none d-lg-table-cell">Score</th>
              <th class="d-none d-lg-table-cell">Points</th>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in result" :key="rowIndex">
                <td>
                  <span v-if="row.start_date">{{new Date(row.start_date).toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' })}}</span>
                </td>
                <td>
                  <p class="mb-0">{{row.draft.name}}</p>
                  <div class="d-lg-none">
                    <div>Zone:&nbsp;{{row.zone_name}}</div>
                    <div>Event:&nbsp;{{row.event_name}}</div>
                    <div>Horse:&nbsp;<tableTextTemplate v-if="row.horse && row.horse.name && row.horse.registration_date" :text="row.horse.name" :link="'Horse Profile'" :slug="row.horse.id" :row="row.horse" :score="true" :options="{ showLinks: true }" />
                    <span v-else-if="row.horse && row.horse.name">{{row.horse.name}}</span>
                    <small v-if="row.horse ? !row.horse.registration_date : false" class="d-block font-italic text-primary">Unregistered</small></div>
                  </div>
                </td>
                <td class="d-none d-lg-table-cell">{{row.zone_name}}</td>
                <td class="d-none d-lg-table-cell">{{row.event_name}}</td>
                <td class="d-none d-lg-table-cell">
                  <tableTextTemplate v-if="row.horse && row.horse.name && row.horse.registration_date" :text="row.horse.name" :link="'Horse Profile'" :slug="row.horse.id" :row="row.horse" :score="true" :options="{ showLinks: true }" />
                  <span v-else-if="row.horse && row.horse.name">{{row.horse.name}}</span>
                  <small v-if="row.horse ? !row.horse.registration_date : false" class="d-block font-italic text-primary">Unregistered</small>
                </td>
                <td>
                  {{row.place}}
                  <div class="d-lg-none">
                    <div>Score:&nbsp;{{row.score}}</div>
                    <div>Points:&nbsp;{{row.points === '0.00' ? '-' : row.points}}</div>
                  </div>
                </td>
                <td class="d-none d-lg-table-cell">{{row.score}}</td>
                <td class="d-none d-lg-table-cell">{{row.points === '0.00' ? '-' : row.points}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else-if="!loaded" class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>

      <div v-else class="alert alert-warning" role="alert">
        There are no results for this rider.
      </div>
    </section>

    <section v-else class="col px-0 pr-lg-3">
      <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import tableTextTemplate from '@/components/DataTableFields/Text'

export default {
  name: 'MemberProfileScore',
  components: {
    tableTextTemplate
  },
  data() {
    return {
      results: {},
      errors: '',
      loaded: false
    }
  },
  methods: {
    getResults(id) {
      this.errors = ''
      axios.get(`${this.$api}/results-rider/${id}`).then((response) => {
        this.loaded = true
        if (response.data.status === 'success' && response.data.data !== null) {
          this.tweakResults(response.data.data)
        } else {
          this.errors = 'There was a server error. Please contact us.'
        }
      }).catch(() => {
        this.loaded = true
        this.errors = 'There was a server error. Please contact us.'
      })
    },
    tweakResults(theData) { // Put results in to a usable format
      const tempResults = {}
      if (Array.isArray(theData.results)) {
        theData.results.forEach((result) => {
          if (typeof tempResults[result.year] === 'undefined') {
            tempResults[result.year] = [result]
          } else {
            tempResults[result.year].push(result)
          }
        })
      } else {
        Object.keys(theData.results).forEach((key) => {
          if (typeof tempResults[theData.results[key].year] === 'undefined') {
            tempResults[theData.results[key].year] = [theData.results[key]]
          } else {
            tempResults[theData.results[key].year].push(theData.results[key])
          }
        })
      }
      this.results = tempResults
    }
  },
  computed: {
    memberId() {
      return this.$route.params.slug
    }
  },
  mounted() {
    this.getResults(this.memberId)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Members/Profile/MemberProfileScore.vue